import React, { PropTypes, Component } from 'react'
import classes from './Lightbox.scss'

class Lightbox extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired
  }

  componentDidMount () {
    window.objectFitImages()
  }

  render () {
    const { children } = this.props
    return (
      <div className='overlay'>
        <div className='overlay-cell'>
          <div className={classes.lightbox}>
            {children}
            <img className={classes.mascot} src='/images/mascot.png' alt='mascot' />
            <div className={classes.btnClose} onClick={this._onOkay}>X</div>
            <div className={classes.button} onClick={this._onOkay}>
              <span>ตกลง</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Lightbox



// WEBPACK FOOTER //
// ./src/components/Lightbox.js